export enum QUEUED_AT {
  "1H" = "1 hour",
  "2H" = "2 hours",
  "6H" = "6 hours",
  "12H" = "12 hours",
  "1DAY" = "1 day",
}
